var LayoutPerspective = require('./../layout/LayoutPerspective');
var billLayoutTemplate = require('./billTabsLayoutTemplate.hbs');
var PortalPerspectiveLayoutBehavior = require('./../PortalPerspectiveLayoutBehavior');
var AsideBehavior = require('./../aside/AsideBehavior');

/**
 * Perspective to display the lists of bills for a patient.
 *
 * @class BillPerspective
 * @constructor
 */
module.exports = LayoutPerspective.extend({
  template: billLayoutTemplate,
  moduleNamespace: 'bill',

  behaviors: {
    portalPerspectiveLayoutBehavior: {
      behavior: PortalPerspectiveLayoutBehavior
    },
    asideBehavior: {
      behavior: AsideBehavior,
      asideHeaderMessageKey: 'bill.aside.header',
      asideContentMessageKey: 'bill.aside'
    }
  },

  prepareFields: {
    patientVecnaId: '_patientVecnaId'
  },

  injectionSites: {
    'bill-tabs': '_billTabsView'
  },

  /**
   * @method initialize
   * @override
   * @param options {Object} the options of this perspective.
   *   @param options.billTabsView {BillTabsView} the shared tabs view to use for this perspective.
   */
  initialize: function(options) {
    LayoutPerspective.prototype.initialize.apply(this);
    this._billTabsView = options.billTabsView;
  }
});
